import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faLocation,
  faLocationPin,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/Buses.css";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons";
import Bus01 from "../images/bus1.jpg";
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import ExpenseTrackerModal from "./Components/StatusSubModal";
import StatusTypeModel from "./Components/StatusSubModal";
import { DatePicker } from "rsuite";

Modal.setAppElement("#root");

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};

export default function BusesPage() {
  const location = useLocation();
  // const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [previewUrlUpdate, setPreviewUrlUpdate] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  //const [Error, setSetError] = useState(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [BusesList, SetBusesList] = useState([]);
  const [BusStatus, SetBusStatus] = useState([]);
  const [selectedBus, setSelectedBus] = useState(null);

  const [isDateInput, setIsDateInput] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const [subModalIsOpen, setSubModalIsOpen] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [statusTypeSub, setStatusTypeSub] = useState({
    Status: null,
    Status_Ref: null,
  });

  const handleSubModalOpen = () => setSubModalIsOpen(true);
  const handleSubModalClose = () => setSubModalIsOpen(false);

  const handleStatusOnChange = async (e) => {
    let { name, value } = e.target;
    setStatusTypeSub({ ...statusTypeSub, [name]: value.toUpperCase() });
  };

  function selectStatusType(statusType) {
    switch (statusType) {
      case "BusStatus":
        return "Bus_Status";
        break;

      default:
        break;
    }
  }

  const handleStatusTypeSubjectSubmit = async (event) => {
    event.preventDefault();
    const status = statusType ? selectStatusType(statusType) : "";
    console.log(status, statusType);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/${status}`,
          statusTypeSub,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            setStatusTypeSub({ Status: null, Status_Ref: null });
            if (statusType === "BusStatus") fetchBusStatus();
            setStatusType(null);
            handleSubModalClose();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const filteredBuses = searchQuery
    ? BusesList.filter((item) =>
        item.Register_Number.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : BusesList;

  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
  const maxSize = 2 * 1024 * 1024;

  const InitState = {
    busName: null,
    modelName: null,
    regNo: null,
    yearofManufacturing: null,
    purchasedDate: null,
    busColour: null,
    capacity: null,
    fuelType: "Petrol",
    mileage: null,
    gpsId: null,
    busStatus: "Active",
    wifi: "Yes",
    engineNumber: null,
    chassisNumber: null,
    rcExpireDate: null,
    insuranceValidUpto: null,
    lastServiceDate: null,
    nextServiceDate: null,
    fastagNumber: null,
    nocStatus: null,
    BusPhoto: "",
    user: username,
  };

  const [formData, setFormData] = useState(InitState);
  let files = new FormData();
  const fetchBusStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Bus_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetBusStatus(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const fetchBusList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/bus/FetchBusList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
      // console.log("Fetched data:", response.data);
      SetBusesList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchBusList();
    fetchBusStatus();
    const isText = Array(4).fill(false);
    setIsDateInput(isText);
    myFunction();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, [1]);

  const SuccessMSG = (msg) => {
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 1000, // Auto-dismiss after 2 seconds
      hideProgressBar: false, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const handleEdit = (bus) => {
    const InitStateEdit = {
      busId: bus.Bus_Id,
      busName: bus.Bus_Name,
      modelName: bus.Model_Name,
      regNo: bus.Register_Number,
      yearofManufacturing: bus.Year_of_Mfc,
      purchasedDate:
        bus.Purchased_Date == null
          ? null
          : convert(bus.Purchased_Date.toString()),
      busColour: bus.Color,
      capacity: bus.Capacity,
      fuelType: bus.Fuel_Type,
      mileage: bus.Mileage,
      gpsId: bus.GPS_Id,
      busStatus: bus.Bus_Status,
      wifi: bus.Wifi,
      engineNumber: bus.Engine_Number,
      chassisNumber: bus.Chassis_Number,
      rcExpireDate:
        bus.Rc_Expire_Date == null
          ? null
          : convert(bus.Rc_Expire_Date.toString()),
      insuranceValidUpto:
        bus.Insurance_Valid_Upto == null
          ? null
          : convert(bus.Insurance_Valid_Upto.toString()),
      lastServiceDate:
        bus.Last_Service_Date == null
          ? null
          : convert(bus.Last_Service_Date.toString()),
      nextServiceDate:
        bus.Next_Service_Date == null
          ? null
          : convert(bus.Next_Service_Date.toString()),
      fastagNumber: bus.Fastag_Number,
      nocStatus: bus.Noc_Status,
      BusPhoto: "",
      busPhoto: bus.Bus_Photo,
      user: username,
    };
    setSelectedBus(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleUpdateFileChange = (e) => {
    let value = e.target.files[0];
    if (!allowedTypes.includes(value.type)) {
      WarningMSG("Only .jpg, .jpeg, .png formats are allowed");
      value = e.target.files[0];
    } else if (value.size > maxSize) {
      WarningMSG("File size should not exceed 2MB");
      value = e.target.files[0];
    } else {
      setSelectedBus({
        ...selectedBus,
        BusPhoto: value,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrlUpdate(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleFileChange = (e) => {
    let value = e.target.files[0];
    if (!allowedTypes.includes(value.type)) {
      WarningMSG("Only .jpg, .jpeg, .png formats are allowed");
      value = e.target.files[0];
    } else if (value.size > maxSize) {
      WarningMSG("File size should not exceed 2MB");
      value = e.target.files[0];
    } else {
      setFormData({
        ...formData,
        BusPhoto: value,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
    //console.log("photo",e.target.files[0]);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if (confirmClose) {
      setModalIsOpen(false);
      setFormData(InitState);
      setSelectedBus(null);
    }
  };

  const handleFocus = (index) => {
    const isText = [...isDateInput];
    isText[index] = true;
    setIsDateInput(isText);
  };

  const handleFocus1 = (index) => {
    const isText = [...isDateInput];
    isText[index] = false;
    setIsDateInput(isText);
  };

  async function myFunction() {
    try {
      const response = await axios.get(
        "https://app.fleettrack.co.in/api/get_vehicles?token=fleettrackapi_c9nZIjOPEXNPvO6RUU4FJTygEAbXBiWY&email=fleettrackapi@gmail.com"
      );
      // console.log(response.data);
      const data = response.data.length > 0 ? response.data[0] : null;
      if (data == null) {
        setLatitude(null);
        setLongitude(null);
      } else {
        setLatitude(data.latitude);
        setLongitude(data.longitude);
      }
    } catch (e) {
      console.error(e);
    }
  }

  // Set the interval for 5 seconds (35000 milliseconds)
  //const interval = setInterval(myFunction, 35000);

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name,value);
    const pattern = /[^a-zA-Z0-9 ]/g;
    const pattern1 = /[^a-zA-Z ]/g;
    const pattern2 = /^[a-zA-Z0-9]*$/g;
    if (name === "busName" || name === "modelName") {
      let result = pattern1.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value
            .replace(pattern1, "")
            .replace(/[^a-zA-Z\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase(),
        });
      }
    } else if (
      name === "gpsId" ||
      name === "engineNumber" ||
      name === "chassisNumber" ||
      name === "fastagNumber" ||
      name === "regNo"
    ) {
      let result = pattern2.test(value);
      if (!result) {
        const val = value.toUpperCase();
        setFormData({
          ...formData,
          [name]: val.replace(/[^a-zA-Z0-9]/g, ""),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.toUpperCase(),
        });
      }
    } else if (name === "nocStatus") {
      let result = pattern1.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z]/g, ""),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "yearofManufacturing") {
      if (value > 9999) {
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "capacity" || name === "mileage") {
      if (value > 99) {
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleChangeDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setFormData({
        ...formData,
        [name]: convert(date),
      });
    }
  };

  const handleUpdateDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setSelectedBus({
        ...selectedBus,
        [name]: convert(date),
      });
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z0-9 ]/g;
    const pattern1 = /[^a-zA-Z]/g;
    const pattern2 = /^[a-zA-Z0-9]*$/g;
    if (name === "busName" || name === "modelName") {
      let result = pattern1.test(value);
      if (result) {
        setSelectedBus({
          ...selectedBus,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setSelectedBus({
          ...selectedBus,
          [name]: value
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .replace(/\s+/g, " ")
            .trim()
            .toUpperCase(),
        });
      }
    } else if (
      name === "gpsId" ||
      name === "engineNumber" ||
      name === "chassisNumber" ||
      name === "fastagNumber" ||
      name === "regNo"
    ) {
      let result = pattern2.test(value);
      if (!result) {
        const val = value.toUpperCase();
        setSelectedBus({
          ...selectedBus,
          [name]: val.replace(/[^a-zA-Z0-9]/g, ""),
        });
      } else {
        setSelectedBus({
          ...selectedBus,
          [name]: value.toUpperCase(),
        });
      }
    } else if (name === "nocStatus") {
      let result = pattern1.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z]/g, ""),
        });
      } else {
        setSelectedBus({
          ...selectedBus,
          [name]: value.toUpperCase(),
        });
      }
    } else if (name === "yearofManufacturing") {
      if (value > 9999) {
        setSelectedBus({
          ...selectedBus,
          [name]: value.slice(0, 4),
        });
      } else {
        setSelectedBus({
          ...selectedBus,
          [name]: value,
        });
      }
    } else if (name === "capacity" || name === "mileage") {
      if (value > 99) {
      } else {
        setSelectedBus({
          ...selectedBus,
          [name]: value,
        });
      }
    } else {
      setSelectedBus({
        ...selectedBus,
        [name]: value,
      });
    }
  };

  const UpdateForm = async (e) => {
    e.preventDefault();
    console.log(selectedBus);
    try {
      //console.log(selectedBus);
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/bus/UpdateBus/${selectedBus.busId}`,
          selectedBus,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
              "Content-Type": "multipart/form-data", // Set content type to multipart/form-data for file upload
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedBus([]);
          fetchBusList();
          setPreviewUrlUpdate("");
          setPreviewUrl("");
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    closeModal();
  };
  const handleDelete = async (Bus) => {
    try {
      const confirm = window.confirm("Are you sure you want to delete this?");
      if (!confirm) return;
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/bus/DeleteBus/${Bus.Bus_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchBusList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const handleSubmit = async (event) => {
    console.log(formData);
    event.preventDefault();
    if (
      formData.insuranceValidUpto === null ||
      formData.rcExpireDate === null
    ) {
      WarningMSG("Fill Mandatory Fields");
    } else {
      try {
        await axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/bus/AddBus`, formData, {
            headers: {
              "content-type": "multipart/form-data",
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              SuccessMSG(res.data.message);
              setPreviewUrl("");
              fetchBusList();
            } else if (res.status === 201) {
              FailedMSG(res.data);
            }
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
        fetchBusList();
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
      //console.log(formData);
      setFormData(InitState);
      closeModal();
    }
  };

  const Locationfetch = async () => {
    const url = `https://www.google.com/maps/place/${latitude}N+${longitude}E/@${latitude},${longitude},zoom_levelz/`;
    window.open(url, "_blank");
  };

  const today = new Date().toISOString().split("T")[0];
  return (
    <>
      <ToastContainer />
      <Appbar username={username} rights={rights}></Appbar>
      <div className="Buses">
        <Menu username={username} rights={rights} i={"MasterSetup"}></Menu>
        <div className="BusesPage">
          <p className="BusesPageHeadLabel">Buses</p>
          <div className="BusesPageHeaders">
            <div className="BusesPageRegSearch">
              <input
                className="BusesPageRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Reg No"
              ></input>
              <button className="BusesPageSearchBtn">
                <FontAwesomeIcon
                  className="BusesPageRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button className="NewBusesBtn" title="Add New" onClick={openModal}>
              Add New{" "}
              <FontAwesomeIcon
                className="BusesAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            contentLabel="Bus Form"
            shouldCloseOnOverlayClick={false}
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "29%",
                right: "29%",
                bottom: "40px",
                height: "auto",
                width: "42%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="BusesPageFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="BusesPageFormHeadLabel">
              {selectedBus?.busId ? "Edit Bus" : "Add Bus"}
            </p>
            <form
              className="BusesPageForm"
              onSubmit={selectedBus?.busId ? UpdateForm : handleSubmit}
            >
              <div className="BusesPageFormFlex">
                <div className="BusesPageform1">
                  <div className="BusesPageForm0l">
                    <div className="BusesPageformFeilds0l">
                      <label className="BusesPageFormLabels">
                        Bus Name <span>*</span>
                      </label>
                      <input
                        placeholder="Bus Name"
                        className="BusesPageFormInputs"
                        value={selectedBus?.busName || formData.busName}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        type="text"
                        name="busName"
                        pattern="[A-Za-z]+"
                        required
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds0l">
                      <label className="BusesPageFormLabels">
                        Model Name <span>*</span>
                      </label>
                      <input
                        placeholder="Model Name"
                        className="BusesPageFormInputs"
                        required
                        value={selectedBus?.modelName || formData.modelName}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        pattern="[a-zA-Z0-9_-]+"
                        type="text"
                        name="modelName"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds0l">
                      <label className="BusesPageFormLabels">
                        Register Number <span>*</span>{" "}
                      </label>
                      <input
                        placeholder="XXXXXXXXXX(10)"
                        className="BusesPageFormInputs"
                        required
                        value={selectedBus?.regNo || formData.regNo}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        minLength={10}
                        maxLength={10}
                        title="Please give 10 digit"
                        type="text"
                        name="regNo"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageForm0r">
                    <div className="BusesPageForm0rflex">
                      <div className="BusesPageFormPhoto">
                        {selectedBus ? (
                          previewUrlUpdate === "" ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${
                                selectedBus.busPhoto === null
                                  ? ""
                                  : selectedBus.busPhoto
                              }`}
                              alt=""
                            ></img>
                          ) : (
                            <img src={previewUrlUpdate} alt=""></img>
                          )
                        ) : previewUrl === "" ? (
                          <img src={InitState.BusPhoto} alt=""></img>
                        ) : (
                          <img src={previewUrl} alt=""></img>
                        )}
                      </div>
                      <div className="BusesPageformFeilds0l">
                        <label className="BusesPageFormLabels">Bus Photo</label>
                        <label
                          htmlFor="busPhoto"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "30px",
                          }}
                          className="BusesPageFormPhotoInputs"
                        >
                          <FontAwesomeIcon icon={faCamera}></FontAwesomeIcon>
                        </label>
                        <input
                          className="BusesPageFormInputs"
                          id="busPhoto"
                          onChange={
                            selectedBus
                              ? handleUpdateFileChange
                              : handleFileChange
                          }
                          style={{ display: "none" }}
                          type="file"
                          accept="image/*"
                          name="BusPhoto"
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="BusesPageForm2f">
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">
                        Year of Manufacturing{" "}
                      </label>
                      <input
                        placeholder="1900"
                        value={
                          selectedBus?.yearofManufacturing ||
                          formData.yearofManufacturing
                        }
                        onChange={selectedBus ? handleUpdate : handleChange}
                        min="0"
                        max="9999"
                        className="BusesPageFormInputs"
                        type="number"
                        name="yearofManufacturing"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">
                        Purchased Date{" "}
                      </label>
                      <input
                        placeholder="01-Jan-1900"
                        className="BusesPageFormInputs"
                        type={isDateInput[0] ? "date" : "text"}
                        onFocus={() => handleFocus(0)}
                        onBlur={() => handleFocus1(0)}
                        readOnly={!isDateInput[0]}
                        max={today}
                        min={
                          selectedBus
                            ? selectedBus.yearofManufacturing
                              ? `${selectedBus.yearofManufacturing}-01-01`
                              : "1900-01-01"
                            : formData.yearofManufacturing
                            ? `${formData.yearofManufacturing}-01-01`
                            : "1900-01-01"
                        }
                        value={
                          selectedBus
                            ? selectedBus.purchasedDate
                              ? FormatDate(selectedBus.purchasedDate)
                              : selectedBus.purchasedDate
                            : formData.purchasedDate
                            ? FormatDate(formData.purchasedDate)
                            : formData.purchasedDate
                        }
                        onChange={(e) =>
                          selectedBus
                            ? handleUpdateDate(e, 0)
                            : handleChangeDate(e, 0)
                        }
                        name="purchasedDate"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">Colour </label>
                      <input
                        placeholder="Colour"
                        className="BusesPageFormInputs"
                        value={selectedBus?.busColour || formData.busColour}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        type="text"
                        name="busColour"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">Capacity </label>
                      <input
                        placeholder="Capacity"
                        className="BusesPageFormInputs"
                        value={selectedBus?.capacity || formData.capacity}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        type="number"
                        name="capacity"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">Fuel Type </label>
                      <select
                        name="fuelType"
                        value={
                          selectedBus ? selectedBus.fuelType : formData.fuelType
                        }
                        onChange={selectedBus ? handleUpdate : handleChange}
                        className="BusesPageFormSelects"
                      >
                        <option value="Petrol">Petrol</option>
                        <option value="Diesel">Diesel</option>
                      </select>
                    </div>
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">Mileage</label>
                      <input
                        placeholder="Mileage"
                        value={selectedBus?.mileage || formData.mileage}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        className="BusesPageFormInputs"
                        type="number"
                        name="mileage"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">GPS Id </label>
                      <input
                        placeholder="GPS Id"
                        type="text"
                        pattern="[a-zA-Z0-9_-]+"
                        maxLength={10}
                        value={selectedBus?.gpsId || formData.gpsId}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        className="BusesPageFormInputs"
                        name="gpsId"
                      ></input>
                    </div>
                    {selectedBus?.busId ? (
                      <div className="BusesPageformFeilds">
                        <label className="BusesPageFormLabels">Location </label>
                        <button
                          className="BusesPageFormSelects"
                          onClick={Locationfetch}
                        >
                          <FontAwesomeIcon icon={faLocation}></FontAwesomeIcon>
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">
                        Bus Status{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{ username: username, rights: rights }}
                          to={""}
                          onClick={() => {
                            setStatusType("BusStatus");
                            handleSubModalOpen();
                          }}
                        >
                          {" "}
                          (Add Status)
                        </Link>{" "}
                      </label>
                      <select
                        className="BusesPageFormSelects"
                        value={
                          selectedBus
                            ? selectedBus.busStatus
                            : formData.busStatus
                        }
                        onChange={selectedBus ? handleUpdate : handleChange}
                        name="busStatus"
                      >
                        <option value={""}>Select</option>
                        {BusStatus.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="BusesPageformFeilds">
                      <label className="BusesPageFormLabels">Wifi </label>
                      <select
                        className="BusesPageFormSelects"
                        value={selectedBus ? selectedBus.wifi : formData.wifi}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        name="wifi"
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="BusesPageForm1f">
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Engine Number{" "}
                      </label>
                      <input
                        placeholder="XXXXXXXXXXXXXXX(16)"
                        value={
                          selectedBus?.engineNumber || formData.engineNumber
                        }
                        onChange={selectedBus ? handleUpdate : handleChange}
                        minLength={16}
                        maxLength={16}
                        title="Please give 16 digit"
                        className="BusesPageFormInputs"
                        type="text"
                        name="engineNumber"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Chassis Number{" "}
                      </label>
                      <input
                        placeholder="XXXXXXXXXXXXXXX(16)"
                        value={
                          selectedBus?.chassisNumber || formData.chassisNumber
                        }
                        onChange={selectedBus ? handleUpdate : handleChange}
                        className="BusesPageFormInputs"
                        minLength={16}
                        maxLength={16}
                        title="Please give 16 digit"
                        type="text"
                        name="chassisNumber"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Rc Expire Date <span>*</span>
                      </label>
                      <input
                        placeholder="01-Jan-1900"
                        className="BusesPageFormInputs"
                        type={isDateInput[1] ? "date" : "text"}
                        onFocus={() => handleFocus(1)}
                        onBlur={() => handleFocus1(1)}
                        readOnly={!isDateInput[1]}
                        value={
                          selectedBus
                            ? selectedBus.rcExpireDate
                              ? FormatDate(selectedBus.rcExpireDate)
                              : selectedBus.rcExpireDate
                            : formData.rcExpireDate
                            ? FormatDate(formData.rcExpireDate)
                            : formData.rcExpireDate
                        }
                        onChange={(e) =>
                          selectedBus
                            ? handleUpdateDate(e, 1)
                            : handleChangeDate(e, 1)
                        }
                        min={today}
                        required
                        name="rcExpireDate"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Insurance Valid Upto <span>*</span>
                      </label>
                      <input
                        placeholder="01-Jan-1900"
                        className="BusesPageFormInputs"
                        type={isDateInput[2] ? "date" : "text"}
                        onFocus={() => handleFocus(2)}
                        onBlur={() => handleFocus1(2)}
                        readOnly={!isDateInput[2]}
                        value={
                          selectedBus
                            ? selectedBus.insuranceValidUpto
                              ? FormatDate(selectedBus.insuranceValidUpto)
                              : selectedBus.insuranceValidUpto
                            : formData.insuranceValidUpto
                            ? FormatDate(formData.insuranceValidUpto)
                            : formData.insuranceValidUpto
                        }
                        onChange={(e) =>
                          selectedBus
                            ? handleUpdateDate(e, 2)
                            : handleChangeDate(e, 2)
                        }
                        min={today}
                        required
                        name="insuranceValidUpto"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Last Service Date{" "}
                      </label>
                      <input
                        className="BusesPageFormInputs"
                        placeholder="01-Jan-1900"
                        type={isDateInput[3] ? "date" : "text"}
                        onFocus={() => handleFocus(3)}
                        onBlur={() => handleFocus1(3)}
                        readOnly={!isDateInput[3]}
                        value={
                          selectedBus
                            ? selectedBus.lastServiceDate
                              ? FormatDate(selectedBus.lastServiceDate)
                              : selectedBus.lastServiceDate
                            : formData.lastServiceDate
                            ? FormatDate(formData.lastServiceDate)
                            : formData.lastServiceDate
                        }
                        onChange={(e) =>
                          selectedBus
                            ? handleUpdateDate(e, 3)
                            : handleChangeDate(e, 3)
                        }
                        max={today}
                        name="lastServiceDate"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Next Service Date{" "}
                      </label>
                      <input
                        className="BusesPageFormInputs"
                        placeholder="01-Jan-1900"
                        type={isDateInput[4] ? "date" : "text"}
                        onFocus={() => handleFocus(4)}
                        onBlur={() => handleFocus1(4)}
                        readOnly={!isDateInput[4]}
                        value={
                          selectedBus
                            ? selectedBus.nextServiceDate
                              ? FormatDate(selectedBus.nextServiceDate)
                              : selectedBus.nextServiceDate
                            : formData.nextServiceDate
                            ? FormatDate(formData.nextServiceDate)
                            : formData.nextServiceDate
                        }
                        onChange={(e) =>
                          selectedBus
                            ? handleUpdateDate(e, 4)
                            : handleChangeDate(e, 4)
                        }
                        min={today}
                        name="nextServiceDate"
                      ></input>
                    </div>
                  </div>
                  <div className="BusesPageform1">
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">
                        Fastag Number{" "}
                      </label>
                      <input
                        placeholder="XXXXXXXXXXXXXXX(16)"
                        value={
                          selectedBus?.fastagNumber || formData.fastagNumber
                        }
                        onChange={selectedBus ? handleUpdate : handleChange}
                        minLength={16}
                        maxLength={16}
                        title="Please give 16 digit"
                        className="BusesPageFormInputs"
                        type="text"
                        name="fastagNumber"
                      ></input>
                    </div>
                    <div className="BusesPageformFeilds1">
                      <label className="BusesPageFormLabels">Noc Status </label>
                      <input
                        placeholder="Noc Status"
                        value={selectedBus?.nocStatus || formData.nocStatus}
                        onChange={selectedBus ? handleUpdate : handleChange}
                        maxLength={10}
                        className="BusesPageFormInputs"
                        type="text"
                        name="nocStatus"
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
              <div className="BusesPageFormFooter">
                <div className="BusesPageFormFooterBtns">
                  <button className="BusesPageFormSubmitBtn" type="submit">
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <StatusTypeModel
            isOpen={subModalIsOpen}
            onClose={handleSubModalClose}
            statusTypeSub={statusTypeSub}
            handleChange={handleStatusOnChange}
            handleSubmit={handleStatusTypeSubjectSubmit}
            statusType={statusType}
          />
          <div className="BusesPageLists">
            {filteredBuses.length < 1 ? (
              <p style={{ textAlign: "center", width: "100%" }}>
                {" "}
                There is No Buses Found
              </p>
            ) : (
              filteredBuses.map((items, index) => {
                return (
                  <div className="BusesPageIndex" key={index}>
                    {items.Bus_Photo ? (
                      <img
                        src={`${process.env.REACT_APP_API_BASE_URL}/${
                          items.Bus_Photo === null ? "" : items.Bus_Photo
                        }`}
                        alt={"img"}
                        className="BusesPageIndexImg"
                      ></img>
                    ) : (
                      <img
                        src={Bus01}
                        alt=""
                        className="BusesPageIndexImg"
                      ></img>
                    )}
                    <div className="BusesPageIndexDetails">
                      <div className="BusesPageIndex0">
                        <div className="BusesPageGrp">
                          <p className="BusesPageGrpValues">{items.Bus_Id}</p>
                        </div>
                        <div className="BusesPageGrp">
                          <p className="BusesPageGrpValues">
                            {items.Model_Name}
                          </p>
                        </div>
                        <div className="BusesPageGrp">
                          <p className="BusesPageGrpValues">
                            {items.Register_Number}
                          </p>
                        </div>
                      </div>
                      <div className="BusesPageIndex1">
                        <div className="BusesPageIndexGrp">
                          {items.Bus_Status === "INACTIVE" ? (
                            <FontAwesomeIcon
                              className="BusesPageIndexGrpStatusIcon"
                              style={{ color: "red", opacity: "0.5" }}
                              icon={faCircleXmark}
                            ></FontAwesomeIcon>
                          ) : (
                            <FontAwesomeIcon
                              className="BusesPageIndexGrpStatusIcon"
                              style={{ color: "green", opacity: "0.5" }}
                              icon={faSquareCheck}
                            ></FontAwesomeIcon>
                          )}
                          <p className="BusesPageGrpValues1">
                            {items.Bus_Status}
                          </p>
                        </div>
                        <div className="BusesPageIndexGrp">
                          <FontAwesomeIcon
                            className="BusesPageIndexGrpPassengerIcon"
                            icon={faPeopleGroup}
                          ></FontAwesomeIcon>
                          <p className="BusesPageGrpValues1">
                            {items.Capacity == null ? " - " : items.Capacity}
                          </p>
                        </div>
                        <div className="BusesPageGrpBtn">
                          <FontAwesomeIcon
                            className="BusesPageEditIcon"
                            onClick={() => handleEdit(items)}
                            title="Edit"
                            icon={faEdit}
                          ></FontAwesomeIcon>
                          <FontAwesomeIcon
                            className="BusesPageDeleteIcon"
                            title="Delete"
                            onClick={() => handleDelete(items)}
                            icon={faTrash}
                          ></FontAwesomeIcon>
                        </div>
                      </div>
                      <div className="BusesPageIndex2">
                        <div className="BusesPageGrp">
                          <p className="BusesPageGrpLables">Rc Expire Date</p>
                          <p className="BusesPageGrpValues">
                            {FormatDate(convert(items.Rc_Expire_Date))}
                          </p>
                        </div>
                        <div className="BusesPageGrp">
                          <p className="BusesPageGrpLables">Insurance Valid</p>
                          <p className="BusesPageGrpValues">
                            {FormatDate(convert(items.Insurance_Valid_Upto))}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
